import mixpanel from 'mixpanel-browser';
import styled from 'styled-components';
import { initializeTracking } from '../lib/track';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfoButton from '../pages/status-overview/info-button.jsx';
import Campaign from './campaign.jsx';
import layout from '../style/layout';


class CampaignLoader extends Component {
    state = {};

    componentDidMount() {
        const params = this.props.params;
        const { backendBaseURL, mpProject } = params.environment;

        initializeTracking(mpProject, () => {
            const extendedQueryParams = Object.assign({
                environment: params.env,
                hostname: window.location.hostname,
                mixpanel: mixpanel.get_distinct_id(),
            }, params.queryParams);

            const idfa = params.queryParams.iOSIdFA || params.queryParams.AndroidIDFA || params.queryParams.device_ifa;

            this.setState({
                backendBaseURL,
                idfa,
                extendedQueryParams,
                trackingtoken: params.trackingtoken,
                placement: params.placement,
                challenge: params.challenge,
            });
        });
    }

    onCampaignLoaded(campaign, response) {
        if (response) {
            const { placementTargeting } = response;
            this.setState({ placementTargeting });
        }
        this.props.onCampaignLoaded(campaign, response);
    }

    render() {
        if (!this.state.backendBaseURL) {
            return null;
        }
        return (
            <div id="app" className={this.props.className}>
                <Campaign
                  {...this.props}
                  {...this.state}
                  onHashKeyKnown={(hashKey) => this.setState({ hashKey })}
                  onToggleSupportButton={(infoButtonIsVisible) =>
                      setTimeout(() => this.setState({ infoButtonIsVisible }), 0)
                  }
                  onCampaignLoaded={(c, r) => this.onCampaignLoaded(c, r)}
                />
                <InfoButton
                  isVisible={this.state.infoButtonIsVisible}
                  baseUrl={this.state.backendBaseURL}
                  hashKey={this.state.hashKey}
                />
                {/* <TestModeRibbon isVisible={this.state.placementTargeting === 'CAMPAIGN_ID'} /> */}
            </div>
        );
    }
}

// Validate all props that are used inside the component to warn early if they're not supplied
// correctly
CampaignLoader.propTypes = {
    params: PropTypes.shape({
        env: PropTypes.string,
        placement: PropTypes.string,
        trackingtoken: PropTypes.string,
        queryParams: PropTypes.objectOf(PropTypes.string),
    }),
};

export default styled(CampaignLoader)`
    ${props => {
        layout.portrait(`background: ${props.style && props.style.background.portrait}`)}
    }
    ${props => {
        layout.landscape(`background: ${props.style && props.style.background.landscape}`)}
    }
`;




// WEBPACK FOOTER //
// ./src/campaign/campaign-loader.jsx